
import fxavatar from "./fx-avatar.vue"; //个人头像组件
import coreavatar from "./core-avatar.vue"; //个人头像组件

import fxtrack from "./fx-track.vue";
// import fxgrid from "./fx-grid.vue";
// import fxfilter from "./fx-filter.vue";
import fxsetgroup from "./fx-setgroup.vue";
import fxsetsort from "./fx-setsort.vue";
import fxsetselect from "./fx-setselect.vue";
// import fxtreeview from "./fx-treeview.vue";
// import fxnotify from "./fx-notify.vue"
// import fxnotify2 from "./fx-notify2.vue";
// import fxnotifyevent from "./fx-notifyevent.vue"
// import fxweboffice from "./fx-weboffice.vue"
import SvgIcon from './SvgIcon/index.vue'; // svg组件
import coreRemind from './remind/app-remind.vue'
import coreGlobalsearch from './globalsearch/searchInput.vue'
import coreUserDropdown from './userDropdown/User.vue'
import init from "./fx-iviewDlg.js"

// 注册到全局 
const fxCtrl = {
  install: function (Vue) {
    init(Vue)
    //标准铃铛
    Vue.component('core-remind', coreRemind);
    //标准全局搜索
    Vue.component('core-globalsearch', coreGlobalsearch);
    //标准用户个人设置
    Vue.component('core-userprofile', coreUserDropdown);

    
    Vue.component('core-avatar', coreavatar);
    
    Vue.component('fx-avatar', fxavatar);
    Vue.component("fx-track", fxtrack);
    // TODO fx-grid 变成动态组件载入
    // Vue.component("fx-grid", fxgrid);
    // Vue.component('fx-notify', fxnotify);
    // Vue.component("fx-notify2", fxnotify2);
    // Vue.component('fx-notifyevent', fxnotifyevent)
    // Vue.component("fx-filter", fxfilter);
    Vue.component("fx-setgroup", fxsetgroup);
    Vue.component("fx-setsort", fxsetsort);
    Vue.component("fx-setselect", fxsetselect);
    Vue.component('svg-icon', SvgIcon)
    // Vue.component("fx-treeview", fxtreeview);
    // Vue.component("fx-weboffice", fxweboffice);
  }

}



export default fxCtrl